module.exports = __webpack_public_path__ + "img/logo-v2-white.bb4ae8a6.svg";